module.exports = __webpack_public_path__ + "static/media/03_01_06.af36fddf.png";